// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"SellAssetFields__checkbox__Hzp4Q"};